'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _taggedTemplateLiteral2 = require('babel-runtime/helpers/taggedTemplateLiteral');

var _taggedTemplateLiteral3 = _interopRequireDefault(_taggedTemplateLiteral2);

var _templateObject = (0, _taggedTemplateLiteral3.default)(['\n  border-radius: ', ';\n  background-color: ', ';\n'], ['\n  border-radius: ', ';\n  background-color: ', ';\n']);

exports.default = Alert;

var _react = require('react');

var React = _interopRequireWildcard(_react);

var _reactEmotion = require('react-emotion');

var _reactEmotion2 = _interopRequireDefault(_reactEmotion);

var _icon = require('../icon');

var _icon2 = _interopRequireDefault(_icon);

var _text = require('../text');

var _text2 = _interopRequireDefault(_text);

var _layout = require('../layout');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TYPE_COLOR_MAP = {
  info: 'blue',
  error: 'pink',
  warning: 'orange',
  confirmation: 'green'
};

var TYPE_ICON_MAP = {
  info: 'info_outline',
  error: 'highlight_off',
  warning: 'error_outline',
  confirmation: 'check_circle'
};

var StyledAlert = /*#__PURE__*/(0, _reactEmotion2.default)(_layout.Box)(_templateObject, function (props) {
  return props.theme.layout.borderRadius;
}, function (props) {
  return props.theme.alerts[props.type];
});

function Alert(props) {
  var children = props.children,
      showIcon = props.showIcon,
      _props$type = props.type,
      type = _props$type === undefined ? 'info' : _props$type,
      _props$justifyContent = props.justifyContent,
      justifyContent = _props$justifyContent === undefined ? 'center' : _props$justifyContent,
      otherProps = (0, _objectWithoutProperties3.default)(props, ['children', 'showIcon', 'type', 'justifyContent']);


  return React.createElement(
    StyledAlert,
    (0, _extends3.default)({
      padding: ['medium', 'large'],
      flexDirection: 'row',
      alignItems: 'center',
      justifyContent: justifyContent,
      role: 'alert',
      type: type
    }, otherProps),
    showIcon ? React.createElement(
      _icon2.default,
      { color: TYPE_COLOR_MAP[type], marginRight: 8 },
      TYPE_ICON_MAP[type]
    ) : null,
    React.createElement(
      _text2.default,
      { color: TYPE_COLOR_MAP[type], size: 'small', multiline: true },
      children
    )
  );
}


//////////////////
// WEBPACK FOOTER
// ./~/@kalo/ui/lib/components/alert/alert.js
// module id = 303
// module chunks = 114276838955818